import { Module } from 'vuex';
import { ApplicationFormState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';
import { detectionRulesRecord } from '../detection_rules_record/index';
import { privilegeIdLendingRecord } from './privilege_id_lending_record/index';

const namespaced: boolean = true;
export const state: ApplicationFormState = {
    forms: undefined,
    formDetails: undefined,
    formCount: 0,
    roles: [],
    node_account_table_per_page: 50,
    templateCheckForConfirmer: false,
    eventLogList: undefined,
    eventLogCount: 0,
    workLogInfo: undefined,
    passwordInfo: undefined,
    numberPerStatusInfo: undefined,
    usableActionsInfo: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    files: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    detectionRules: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    mailDestinations: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    action: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    eventLogs: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    workLogs: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    uploadFile: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    uploadFiles: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroyFiles: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    notification: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    numberPerStatus: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    usableActions: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    attachmentFileDownload: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const applicationForm: Module<ApplicationFormState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    modules: {
        detectionRulesRecord,
        privilegeIdLendingRecord,
    },
};
